import React, { useMemo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Grid, Typography, Box, CircularProgress, TextField, MenuItem, Chip } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import LoaderCircular from 'ui-component/LoaderCircular';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { gridSpacing } from 'store/constant';

// const columns = [
//   { field: 'date', headerName: 'Date', width: 180 },
//   { field: 'impressions', headerName: 'Impressions', width: 180 },
//   { field: 'media_cost', headerName: 'Spends', width: 180 },
//   { field: 'cpc', headerName: 'CPC', width: 150 },
//   { field: 'cpm', headerName: 'CPM', width: 150 },
//   { field: 'view_product', headerName: 'View Product', width: 180 },
//   { field: 'add_to_cart', headerName: 'Add To Cart', width: 180 },
//   { field: 'initiate_checkout', headerName: 'Initiate Checkout', width: 180 },
//   { field: 'purchases_day_0', headerName: 'D0 Checkouts', width: 180 },
//   { field: 'purchase_value_day_0', headerName: 'D0 Checkout Revenue', width: 180 },
//   { field: 'd0_cpp', headerName: 'D0 CPP', width: 180 },
//   { field: 'd0_roas', headerName: 'D0 ROAS', width: 150 },
//   { field: 'purchases_day_1', headerName: 'D1 Checkouts', width: 180 },
//   { field: 'purchase_value_day_1', headerName: 'D1 Checkout Revenue', width: 180 },
//   { field: 'd1_cpp', headerName: 'D1 CPP', width: 180 },
//   { field: 'd1_roas', headerName: 'D1 ROAS', width: 150 },
//   { field: 'purchases_day_3_sum', headerName: 'D3 Checkouts', width: 180 },
//   { field: 'purchase_value_day_3_sum', headerName: 'D3 Checkout Revenue', width: 180 },
//   { field: 'd3_cpp', headerName: 'D3 CPP', width: 180 },
//   { field: 'd3_roas', headerName: 'D3 ROAS', width: 150 },
//   { field: 'purchases_day_7_sum', headerName: 'D7 Checkouts', width: 180 },
//   { field: 'purchase_value_day_7_sum', headerName: 'D7 Checkout Revenue', width: 180 },
//   { field: 'd7_cpp', headerName: 'D7 CPP', width: 180 },
//   { field: 'd7_roas', headerName: 'D7 ROAS', width: 150 }
// ];
const columns = [
  { field: 'date', headerName: 'Date', width: 100 },
  // { field: 'media_cost', headerName: 'Spends', width: 180 },
  {
    field: 'media_cost',
    headerName: 'Spend',
    width: 100,
    valueFormatter: (params) => (params.value !== undefined ? `$ ${splitDigits(roundToTwoDecimal(params.value))}` : '$ 0')
  },
  {
    field: 'cpm',
    headerName: 'CPM',
    width: 80,
    valueFormatter: (params) => (params.value !== undefined ? `$ ${splitDigits(roundToTwoDecimal(params.value))}` : '$ 0')
  },
  { field: 'impressions', headerName: 'Impressions', width: 100, valueFormatter: (params) => splitDigits(params.value) },
  { field: 'view_product', headerName: 'View Product', width: 100, valueFormatter: (params) => splitDigits(params.value) },
  { field: 'add_to_cart', headerName: 'Add To Cart', width: 100, valueFormatter: (params) => splitDigits(params.value) },
  { field: 'initiate_checkout', headerName: 'Initiate Checkout', width: 130, valueFormatter: (params) => splitDigits(params.value) },
  { field: 'purchases_day_1', headerName: 'D1 Checkouts', width: 120 },
  {
    field: 'purchase_value_day_1',
    headerName: 'D1 Checkout Revenue',
    width: 160,
    valueFormatter: (params) => (params.value !== undefined ? `$ ${splitDigits(roundToTwoDecimal(params.value))}` : '$ 0')
  },
  {
    field: 'd1_roas',
    headerName: 'D1 ROAS',
    width: 80,
    valueFormatter: (params) => (params.value !== undefined ? `${splitDigits(roundToTwoDecimal(params.value))}` : '0')
  },
  {
    field: 'd1_cpp',
    headerName: 'D1 CPP',
    width: 80,
    valueFormatter: ({ value }) => {
      const num = Number(value);
      if (num === -999) return '–'; // special case
      if (value === undefined || value === null || isNaN(num)) return '0';

      return `$ ${splitDigits(roundToTwoDecimal(num))}`;
    }
  },
  { field: 'purchases_day_3_sum', headerName: 'D3 Checkouts', width: 120 },
  {
    field: 'purchase_value_day_3_sum',
    headerName: 'D3 Checkout Revenue',
    width: 160,
    valueFormatter: (params) => (params.value !== undefined ? `$ ${splitDigits(roundToTwoDecimal(params.value))}` : '$ 0')
  },
  {
    field: 'd3_roas',
    headerName: 'D3 ROAS',
    width: 80,
    valueFormatter: (params) => (params.value !== undefined ? `${splitDigits(roundToTwoDecimal(params.value))}` : '0')
  },
  {
    field: 'd3_cpp',
    headerName: 'D3 CPP',
    width: 80,
    valueFormatter: ({ value }) => {
      const num = Number(value);
      if (num === -999) return '–'; // special case
      if (value === undefined || value === null || isNaN(num)) return '0';

      return `$ ${splitDigits(roundToTwoDecimal(num))}`;
    }
  },
  { field: 'purchases_day_7_sum', headerName: 'D7 Checkouts', width: 120 },
  {
    field: 'purchase_value_day_7_sum',
    headerName: 'D7 Checkout Revenue',
    width: 160,
    valueFormatter: (params) => (params.value !== undefined ? `$ ${splitDigits(roundToTwoDecimal(params.value))}` : '$ 0')
  },
  {
    field: 'd7_roas',
    headerName: 'D7 ROAS',
    width: 80,
    valueFormatter: (params) => (params.value !== undefined ? `${splitDigits(roundToTwoDecimal(params.value))}` : '0')
  },
  {
    field: 'd7_cpp',
    headerName: 'D7 CPP',
    width: 80,
    valueFormatter: ({ value }) => {
      const num = Number(value);
      if (num === -999) return '–'; // special case
      if (value === undefined || value === null || isNaN(num)) return '0';

      return `$ ${splitDigits(roundToTwoDecimal(num))}`;
    }
  }
];

function splitDigits(num) {
  return Number(num).toLocaleString();
}
function roundToTwoDecimal(value) {
  if (value == '-999') return '-';
  // return Math.round((value + Number.EPSILON) * 100) / 100;
  return (Math.round((value + Number.EPSILON) * 10000) / 10000).toFixed(2);
}

const D2CRequestDataView = ({ loading, d2cData, error, isDollar }) => {
  const [filters, setFilters] = useState({
    country: [],
    campaign_name: [],
    hour: [],
    creative_name: []
  });

  const [filteredData, setFilteredData] = useState(d2cData || []);

  // Extract unique options for dropdowns
  const uniqueValues = useMemo(() => {
    if (!d2cData) return {};
    return {
      country: [...new Set(d2cData.map((d) => d.country).filter(Boolean))],
      campaign_name: [...new Set(d2cData.map((d) => d.campaign_name).filter(Boolean))],
      hour: [...new Set(d2cData.map((d) => d.hour).filter(Boolean))],
      creative_name: [...new Set(d2cData.map((d) => d.creative_name).filter(Boolean))]
    };
  }, [d2cData]);

  // Apply filters
  useEffect(() => {
    if (!d2cData) return;
    let tempData = [...d2cData];

    Object.keys(filters).forEach((key) => {
      if (filters[key].length > 0) {
        tempData = tempData.filter((row) => filters[key].includes(row[key]));
      }
    });

    setFilteredData(tempData);
  }, [filters, d2cData]);

  const handleFilterChange = (field, values) => {
    setFilters((prev) => ({
      ...prev,
      [field]: values
    }));
  };

  const columnVisibilityModel = useMemo(() => {
    return isDollar ? { media_cost_local_currency: false, media_cost: true } : { media_cost_local_currency: true, media_cost: false };
  }, [isDollar]);

  if (loading) {
    return (
      <MainCard>
        <Grid container spacing={gridSpacing} textAlign="center">
          <Grid item xs={12}>
            <Typography variant="h4">Overview Report On Real Time</Typography>
          </Grid>
          <Grid item xs={12}>
            <div style={{ height: '200px', width: '100%' }}>
              <LoaderCircular show />
            </div>
          </Grid>
        </Grid>
      </MainCard>
    );
  }

  if (!d2cData || d2cData.length === 0) {
    return (
      <MainCard>
        <Grid container spacing={gridSpacing} textAlign="center">
          <Grid item xs={12}>
            <Typography variant="h4">Overview Report On Real Time</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              {error?.length ? (
                'No Data Found'
              ) : (
                <>
                  Please click <b>Apply Filter</b> to view data
                </>
              )}
            </Typography>
          </Grid>
        </Grid>
      </MainCard>
    );
  }

  return (
    <MainCard>
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12} textAlign="center">
          <Typography variant="h4">Overview Report On Real Time</Typography>
        </Grid>

        {/* --- FILTER BAR --- */}
        {/* <Grid item xs={12} mt={2}>
          <Grid container spacing={2}>
            {['campaign_name', 'creative_name','hour', 'country'].map((field) => (
              <Grid item xs={12} sm={6} md={3} key={field}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label={field.replace('_', ' ').toUpperCase()}
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )
                  }}
                  value={filters[field]}
                  onChange={(e) => handleFilterChange(field, e.target.value)}
                >
                  {uniqueValues[field]?.map((value) => (
                    <MenuItem key={value} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            ))}
          </Grid>
        </Grid> */}

        {/* --- DATA GRID --- */}
        <Grid item xs={12} mt={3}>
          <Box>
            <div style={{ width: '100%' }}>
              <DataGrid
                rows={filteredData}
                columns={columns}
                initialState={{
                  pagination: { paginationModel: { pageSize: 10 } },
                  sorting: { sortModel: [{ field: 'campaign_name', sort: 'asc' }] }
                }}
                components={{ LoadingOverlay: CircularProgress }}
                loading={loading}
                pageSizeOptions={[10, 20, 30]}
                slots={{ toolbar: GridToolbar }}
                disableRowSelectionOnClick
                disableColumnSelector
                disableDensitySelector
                columnVisibilityModel={columnVisibilityModel}
                autoHeight
                getRowHeight={() => 'auto'}
                className="custom-datagrid"
              />
            </div>
          </Box>
        </Grid>
      </Grid>
    </MainCard>
  );
};

const mapStateToProps = (state) => ({
  loading: state.d2cReducer.loading,
  d2cData: state.d2cReducer.d2cData,
  error: state.d2cReducer.error,
  isDollar: state.campaignReducer.isDollar
});

export default connect(mapStateToProps)(D2CRequestDataView);
